import React, { useContext, useEffect, useState } from "react";
import PedidosContext from "../../../../Context/Pedidos/PedidosContext";
import Card from "../Card/Card";
import { Alert, Box, Grid } from "@mui/material";
import OrdersSkeleton from "../OrdersSkeleton";

const CancelOrders = () => {
  const [active, setActive] = useState(-1);
  const [loading, setLoading] = useState(true);
  const handleCollapse = (indx) => {
    setActive(active === indx ? -1 : indx);
  };
  const { orders_client, GetPedidosCancelados } = useContext(PedidosContext);
  useEffect(() => {
    setLoading(true);
    const result = GetPedidosCancelados();
    if (result && typeof result.finally === "function") {
      result.finally(() => setLoading(false));
    } else {
      setTimeout(() => setLoading(false), 500);
    }
  }, []);

  if (loading) return <OrdersSkeleton count={3} />;

  return (
    <Box sx={{ mt: 1 }}>
      {orders_client.length > 0 ? (
        <Grid container spacing={2}>
          {orders_client.map((order, index) => (
            <Grid item xs={12} key={index}>
              <Card
                index={index}
                onCollapse={handleCollapse}
                order={order}
                active={active}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Alert severity="info" sx={{ mt: 2, borderRadius: 2, border: "1px solid #E3F2FD" }}>
          No tienes pedidos cancelados.
        </Alert>
      )}
    </Box>
  );
};

export default CancelOrders;
